import axios from 'axios';
// import router from './router/index';

const create_instance = axios.create({
    baseURL: '/api/v1.0',
    headers: {
        'Content-type': 'application/json',
    },
});

import { addErrorNotification } from '@/lib/notifications';
import * as errors from '@/errors';

create_instance.interceptors.response.use(
    function(response) {
        return response;
    },
    function(error) {
        const status = error.response.status;

        if (status === 401 && error.response.config.url == '/user') {
            addErrorNotification('Please log in!');
            // router.replace({ path: '/dashboard' });
            throw new errors.UnauthorizedError(error);
        }

        if (status === 504 || status === 502) {
            addErrorNotification(
                'Service temporaraly unavailable. Please try again later.'
            );
            throw new errors.ServiceUnavailable();
        }

        if (status === 400) {
            throw new errors.ApiError(
                error.response.data.message,
                error.response.data.apiCode
            );
        }
        return Promise.reject(error);
    }
);

export { create_instance };
